import {
  getModule,
  Module,
  Mutation,
  MutationAction,
  VuexModule,
} from "vuex-module-decorators";
import store from "@/store/deliveryRegisterInput";

/**
 * ユーザー属性 Store
 */
@Module({ dynamic: true, store: store, name: "deliveryRegisterInputStore" })
class DeliveryRegisterInputStore extends VuexModule {
  public zip_code = "";
  public pref_name = "";
  public user_id = "";
  public areaDialog = false;
  public getAvailableDate = "";
  public deliveryJson = "";
  public tmp_member_id = "";
  public house_card = "";
  public register_no = 0;
  public receipt_no = 0;
  public payment_amount = 0;

  /**
   * 値を持っているか
   */
  get hasValue(): boolean {
    return (
      this.zip_code !== "" ||
      this.pref_name !== "" ||
      this.user_id !== "" ||
      this.tmp_member_id !== ""
    );
  }

  get getZipCode(): string {
    return this.zip_code;
  }

  // 値をクリアするメソッド
  @Mutation
  clearValues(): void {
    this.zip_code = "";
    this.pref_name = "";
    this.user_id = "";
    this.areaDialog = false;
    this.getAvailableDate = "";
    this.deliveryJson = "";
    this.tmp_member_id = "";
    this.house_card = "";
    this.register_no = 0;
    this.receipt_no = 0;
    this.payment_amount = 0;
  }

  /**
   * ユーザー属性値を設定
   *
   * @param deliveryRegisterInput
   */
  @MutationAction({
    rawError: true,
    mutate: [
      "zip_code",
      "pref_name",
      "user_id",
      "areaDialog",
      "getAvailableDate",
      "deliveryJson",
      "tmp_member_id",
      "house_card",
      "register_no",
      "receipt_no",
      "payment_amount",
    ],
  })
  async setupValue(deliveryRegisterInput: {
    zip_code: string;
    pref_name: string;
    user_id: string;
    areaDialog: boolean;
    getAvailableDate: string;
    deliveryJson: string;
    tmp_member_id: string;
    house_card?: string;
    register_no?: number;
    receipt_no?: number;
    payment_amount?: number;
  }): Promise<{
    zip_code: string;
    pref_name: string;
    user_id: string;
    areaDialog: boolean;
    getAvailableDate: string;
    deliveryJson: string;
    tmp_member_id: string;
    house_card: string;
    register_no: number;
    receipt_no: number;
    payment_amount: number;
  }> {
    return {
      zip_code: deliveryRegisterInput.zip_code,
      pref_name: deliveryRegisterInput.pref_name,
      user_id: deliveryRegisterInput.user_id,
      areaDialog: deliveryRegisterInput.areaDialog,
      getAvailableDate: deliveryRegisterInput.getAvailableDate,
      deliveryJson: deliveryRegisterInput.deliveryJson,
      tmp_member_id: deliveryRegisterInput.tmp_member_id,
      house_card: deliveryRegisterInput.house_card ?? "",
      register_no: deliveryRegisterInput.register_no ?? 0,
      receipt_no: deliveryRegisterInput.receipt_no ?? 0,
      payment_amount: deliveryRegisterInput.payment_amount ?? 0,
    };
  }
}
export default getModule(DeliveryRegisterInputStore, store);
